import { Link } from "react-router-dom";
import { Crown } from "lucide-react";

export function AdBanner({ testId = "ad-banner" }) {
  return (
    <div data-testid={testId} className="border border-dashed border-white/20 bg-white/[0.02] p-4 flex items-center justify-between gap-4">
      <div>
        <div className="font-mono-caps text-[9px] text-muted-foreground mb-1">Advertisement</div>
        <div className="text-sm text-muted-foreground">Tired of ads? Upgrade for an ad-free experience.</div>
      </div>
      <Link to="/premium" data-testid="ad-upgrade-link" className="shrink-0 flex items-center gap-1.5 bg-primary text-primary-foreground font-mono-caps text-[10px] px-3 py-2 hover-lift border border-primary">
        <Crown size={13} /> Remove Ads
      </Link>
    </div>
  );
}
